import FloodFill from 'q-floodfill-hsl';

export function Qfill(imageData){
    const qfill = FloodFill.default;
    return new qfill(imageData);
}